import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initGA4, trackGA4PageView } from "./ga4";

export const GA4RouteTracker = () => {
  const location = useLocation();
  const lastUrl = useRef(null);

  useEffect(() => {
    initGA4();
  }, []);

  useEffect(() => {
    const url = `${location.pathname}${location.search}${location.hash}`;
    if (url === lastUrl.current) return;
    lastUrl.current = url;
    trackGA4PageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
};
